import type {
  AppData,
  CompRef,
  DocumentServicesObject,
  DsItem,
} from '@wix/document-services-types';
import type { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';

export interface SelectedComponentData {
  appData?: AppData;
  origCompData?: DsItem;
  selectedComp?: CompRef;
}

const getSelectedComponentAppData = async (
  platformApiMethods: PlatformApiMethods,
  documentServicesAPI: DocumentServicesObject,
): Promise<SelectedComponentData> => {
  const [selectedComp] =
    await platformApiMethods.editor.selection.getSelectedComponents();

  if (!selectedComp) {
    return {};
  }

  const origCompData = documentServicesAPI.components.data.get(selectedComp);

  if (!origCompData?.appDefinitionId) {
    return {
      selectedComp,
      origCompData,
    };
  }

  const appData = documentServicesAPI.tpa.app.getDataByAppDefId(
    origCompData.appDefinitionId,
  );

  return {
    appData,
    origCompData,
    selectedComp,
  };
};

export { getSelectedComponentAppData };
